import { ILang } from "../../../hook/useMultiLanguage";
import { MISSION_STATUS, TYPE } from "../../constants/moduleConsts";
import { searchListWorkUnit, searchPhongBan } from "../../services/services";
import { ISendPeopleTraining } from "../models/sendPeopleTrainingModels";

export const INIT_SEND_PEOPLE_TRAINING: ISendPeopleTraining = {
  hieuLucTuNgay: "",
  hieuLucDenNgay: "",
  tenKhoaDaoTao: "",
  noiDaoTao: "",
  trangThai: null,
  note: "",
  fileId: "",
  fileName: "",
  ngayQuyetDinh: "",
  soQuyetDinh: "",
  khoaPhongNhanQuyetDinh: "",
  nguoiKy: null,
  nguoiKyId: "",
  nguoiKyText: "",
  employeeId: "",
  maNhanVien: "",
  tenNhanVien: "",
  donViCongTacId: "",
  donViCongTacText: "",
  phongBanId: "",
  phongBanText: "",
  chucDanhId: "",
  chucDanhText: "",
  soTiet: null,
  hasCertificate: false,
  birthDate: null
};

export const ListSearch = (lang: ILang) => {
  return [
    {
      name: lang("PROFILE.CODE"),
      field: "maNhanVien",
      type: TYPE.TEXT,
    },
    {
      name: lang("PROFILE.NAME"),
      field: "tenNhanVien",
      type: TYPE.TEXT,
    },
    {
      name: lang("GENERAL.CURRENT_ORGANIZATION"),
      field: "donViCongTacId",
      searchFunction: searchListWorkUnit,
      type: TYPE.SELECT,
    },
    {
      name: lang("INPUT.DEPARTMENTS"),
      field: "phongBanIds",
      searchFunction: searchPhongBan,
      type: TYPE.SELECT,
      isMulti: true,
    },
    {
      name: lang("SEND_PEOPLE_TRAINING.NAME"),
      field: "tenKhoaDaoTao",
      type: TYPE.TEXT,
    },
    {
      name: lang("SEND_PEOPLE_TRAINING.LOCATION"),
      field: "noiDaoTao",
      type: TYPE.TEXT,
    },
    {
      name: lang("GENERAL.STATUS"),
      field: "trangThai",
      type: TYPE.SELECT,
      listOption: MISSION_STATUS,
      isMulti: true,
    },
  ]
}

export const styleTemplateBaoCaoTongHop = `
  @page {
    size: A4 landspace;
    margin: 15mm;
  }

  @media print {
    html, body {
      margin: 0;
      padding: 0;
      font-family: "Times New Roman", serif;
      color: #000;
    }

    #content-print {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }

    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid black; text-align: center; }

    .word {
      width: 100%;
      page-break-inside: avoid;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th, td {
      border: 1px solid #000 !important;
      padding: 4px 8px;
      font-size: 12pt;
    }

    .text-center {
      text-align: center;
    }

    .fw-600 {
      font-weight: 600;
    }

    .text-uppercase {
      text-transform: uppercase;
    }

    .ml-5 { margin-left: 5px; }
    .ml-80 { margin-left: 80px; }
    .mt-16 { margin-top: 16px; }
    .mb-00 { margin-bottom: 100px; }

    .flex {
      display: flex;
    }

    .flex-between {
      justify-content: space-between;
    }

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    .flex-end {
      justify-content: flex-end;
    }

    .align-start {
      align-items: flex-start;
    }

    .max-w-300 {
      max-width: 300px;
    }

    .pl-10 {
      padding-left: 10px;
    }
  }
`;

export const styleTemplateBaoCaoCaNhan = `
   @page {
    size: A4 portrait;
    margin: 15mm;
  }
  
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
      font-family: "Times New Roman", serif;
      color: #000;
    }

    #content-print {
      width: 180mm;
      margin-left: auto;
      margin-right: auto;
    }

    .print-page-break {
      page-break-after: always;
      break-after: page;
    }

    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid black; text-align: center; }

    .word {
      width: 100%;
      page-break-inside: avoid;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th, td {
      border: 1px solid #000 !important;
      padding: 4px 8px;
      font-size: 12pt;
    }

    .text-center {
      text-align: center;
    }

    .fw-600 {
      font-weight: 600;
    }

    .text-uppercase {
      text-transform: uppercase;
    }

    .ml-5 { margin-left: 5px; }
    .ml-100 { margin-left: 100px; }
    .mt-16 { margin-top: 16px; }
    .mb-00 { margin-bottom: 100px; }

    .flex {
      display: flex;
    }

    .flex-between {
      justify-content: space-between;
    }

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    .flex-end {
      justify-content: flex-end;
    }

    .align-start {
      align-items: flex-start;
    }

    .max-w-300 {
      max-width: 300px;
    }

    .pl-10 {
      padding-left: 10px;
    }
  }
`;